import { ArrowDown } from "lucide-react";
import { Reveal, Label } from "./Motion";

const cycle = [
  { key: "Data", q: "What is actually happening?" },
  { key: "Insight", q: "Why is it happening?" },
  { key: "Decision", q: "What should we do?" },
  { key: "Action", q: "How do we implement it?" },
  { key: "Measurement", q: "Did it work?" },
  { key: "Elevation", q: "What should we improve next?" },
];

export default function ElevareCycle() {
  return (
    <section id="cycle" data-testid="elevare-cycle-section" className="relative py-28 lg:py-40 bg-[#0f2624] overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f2624] via-[#122b28] to-[#0f2624]" />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <Label variant="dark">The core idea</Label>
          <h2 className="mt-6 font-head text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-white">
            The Elevare Cycle.<br />
            <span className="text-white/40">Data Becomes Elevation.</span>
          </h2>
          <p className="mt-6 text-base lg:text-lg leading-relaxed text-white/60">
            Every engagement runs on one continuous loop — turning raw data into decisions,
            decisions into action, and action into measurable improvement.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
          {cycle.map((step, i) => (
            <Reveal key={step.key} delay={i * 0.07}>
              <div
                data-testid={`cycle-step-${i}`}
                className="relative h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-8"
              >
                <div className="flex items-baseline gap-4">
                  <span className="font-head text-2xl font-light text-[#c9a961] tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-head text-2xl text-white tracking-wide uppercase">{step.key}</h3>
                </div>
                <p className="mt-4 text-base leading-relaxed text-white/60">{step.q}</p>
                {i < cycle.length - 1 && (
                  <ArrowDown className="absolute -bottom-3 left-1/2 -translate-x-1/2 h-5 w-5 text-[#c9a961]/70 md:hidden" strokeWidth={1.6} />
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-12 text-center text-sm uppercase tracking-[0.3em] text-white/40">
            …then it begins again. <span className="text-[#c9a961]">This is the Elevare cycle.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
